/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="./reportingHierarchyLocations.controller.ts" />

module Meevo.Components.Controls {
    "use strict";

    var reportingHierarchyLocations: angular.IComponentOptions = {
        templateUrl: 'app/components/controls/reportingHierarchyLocations/reportingHierarchyLocations.template.html',
        bindings: {
            businessTypeForHierarchy: "=?",
            hierarchyForHierarchy: "=?",
            locationForHierarchy: "=?",
            branchIdForHierarchy: "=?",
            revision: "=ngModel",
            shortCut: "=?",
            excludedLocationList: "=?",
            disabled: '=?ngDisabled',
            originalModel: "=?",
            reportAvailability: "=?",
            isBusinessTypesModuleEnabled: "=?",
            reportId: "=?"
        },
        require: {
            'ngModelCtrl': 'ngModel'
        },
        controller: ReportingHierarchyLocationsCtrl
    }

    angular.module("meevo.components.controls")
        .component("meevoReportingHierarchyLocations", reportingHierarchyLocations);
}